import React from 'react'
import PropTypes from 'prop-types'
import CodeForm from './CodeForm'
import {
  FILTER_CODE,
  SEARCH_PARAM_CLIENT_CODE,
  SEARCH_PARAM_CONTRACT_NUMBER,
  SEARCH_PARAM_PROMO_CODE
} from '../../../constants'

const ProfessionalCode = ({
  titles,
  codeChange,
  filterApplyAction,
  activeField, values,
  validate,
  syncErrors,
  clearFormInput,
}) => {
  const {
    form: {
      labels, placeholders,
    },
  } = titles

  const codeChangeHandle = (...args) => {
    codeChange(args[3], args[1])
    filterApplyAction(FILTER_CODE, false)
  }

  const onClearInput = (...args) => {
    const relatedInputName = args[0].currentTarget.dataset.rel
    filterApplyAction(FILTER_CODE, false)

    if (relatedInputName === SEARCH_PARAM_CLIENT_CODE || relatedInputName === SEARCH_PARAM_CONTRACT_NUMBER) {
      codeChange('error', '')
    }

    if (relatedInputName === SEARCH_PARAM_PROMO_CODE) {
      codeChange('errorPromo', '')
      codeChange('wrongPromoCodeMessage', '')
      codeChange('wrongPromoCode', '')
    }

    codeChange(relatedInputName, '')
    clearFormInput(relatedInputName)
  }

  return (
    <div className="filter-code">
      <CodeForm
        labels={labels}
        placeholders={placeholders}
        codeChange={codeChangeHandle}
        activeField={activeField}
        values={values}
        validate={validate}
        syncErrors={syncErrors}
        clearInput={onClearInput}
      />
    </div>
  )
}

ProfessionalCode.propTypes = {
  titles: PropTypes.objectOf(Object).isRequired,
  codeChange: PropTypes.func.isRequired,
  filterApplyAction: PropTypes.func.isRequired,
  activeField: PropTypes.string,
  values: PropTypes.objectOf(Object),
  validate: PropTypes.arrayOf(PropTypes.func).isRequired,
  syncErrors: PropTypes.objectOf(PropTypes.string),
  clearFormInput: PropTypes.func.isRequired,
}

ProfessionalCode.defaultProps = {
  activeField: '',
  values: null,
  syncErrors: {},
}
export default ProfessionalCode
